import { render, staticRenderFns } from "./processTaskRuleDetailView.vue?vue&type=template&id=60166823&"
import script from "./processTaskRuleDetailView.vue?vue&type=script&lang=js&"
export * from "./processTaskRuleDetailView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports